var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1766564220510,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1609,
    "data-spm-anchor-id": "a313x.search_index.0.i0.39a03a81EOeasi",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 288h704v192H160z",
    fill: "#087667",
    "p-id": 1610
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M864 960H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32zM192 896h640V128H192v768z",
    fill: "#087667",
    "p-id": 1611
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M864 320H160a32 32 0 0 1 0-64h704a32 32 0 1 1 0 64z",
    fill: "#087667",
    "p-id": 1612
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M864 320H160a32 32 0 0 1 0-64h704a32 32 0 1 1 0 64zM864 512H160a32 32 0 0 1 0-64h704a32 32 0 1 1 0 64zM736 644h-128a32 32 0 1 1 0-64h128a32 32 0 1 1 0 64z",
    fill: "#087667",
    "p-id": 1613
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdc);
export default __webpack_public_path__ + "static/media/idc.de40cab34b6a4bfc6c44cb5fdb831f69.svg";
export { ForwardRef as ReactComponent };